module.exports = __webpack_public_path__ + "img/工单作业量统计.72a021f2.png";